import { render, staticRenderFns } from "./plan-segment-link.vue?vue&type=template&id=340e6338"
import script from "./plan-segment-link.js?vue&type=script&lang=js&external"
export * from "./plan-segment-link.js?vue&type=script&lang=js&external"
import style0 from "./plan-segment-link.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports